var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRestSection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.1 10.34L8.93 7.51L2.74 1.33C2.26 0.850003 1.43 0.980003 1.13 1.6C0.420002 3.09 0.680002 4.92 1.91 6.16L6.1 10.34ZM12.88 8.53C14.41 9.24 16.56 8.74 18.15 7.15C20.06 5.24 20.43 2.5 18.96 1.03C17.5 -0.429997 14.76 -0.0699967 12.84 1.84C11.25 3.43 10.75 5.58 11.46 7.11L2.4 16.17C2.21302 16.357 2.10798 16.6106 2.10798 16.875C2.10798 17.1394 2.21302 17.393 2.4 17.58C2.58698 17.767 2.84058 17.872 3.105 17.872C3.36943 17.872 3.62302 17.767 3.81 17.58L10 11.41L16.18 17.59C16.2726 17.6826 16.3825 17.756 16.5035 17.8061C16.6244 17.8562 16.7541 17.882 16.885 17.882C17.0159 17.882 17.1456 17.8562 17.2665 17.8061C17.3875 17.756 17.4974 17.6826 17.59 17.59C17.6826 17.4974 17.756 17.3875 17.8061 17.2665C17.8562 17.1456 17.882 17.0159 17.882 16.885C17.882 16.7541 17.8562 16.6244 17.8061 16.5035C17.756 16.3825 17.6826 16.2726 17.59 16.18L11.41 10L12.88 8.53Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestSection);
export default __webpack_public_path__ + "static/media/restSection.5ac616f2.svg";
export { ForwardRef as ReactComponent };